import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export interface NCDData {
  ipoName: string;
  ipoBidName: string;
  issuePrice: number;
  rating: string;
  startDt: string;
  endDt: string;
  logoUrl: string;
}

export interface NCDResponseData {
  ncdList: NCDData[];
  showMore: boolean;
  showLess: boolean;
}

export const fetchNCDStocks = async (page: number, limit: number) => {
  const response = await request<NCDResponseData>({
    method: "POST",
    url: API_PATHS.ncd,
    data: {
      page: page ?? 1,
      limit: limit ?? 10,
    },
  });
  return response?.data;
};
